/**
 * Asynchronously loads the component for CreateTransaction
 */

import { lazyLoad } from 'utils/loadable';
import LoadingSpinner from 'app/components/Loading/LoadingSpinner';

export const CreateTransaction = lazyLoad(
    () => import('./index'),
    module => module.CreateTransaction,
    { fallback: <LoadingSpinner /> },
);
